import React, { CSSProperties, FC } from "react";

export interface MascotSleepingProps {
  mode: "light" | "dark";
  style?: CSSProperties;
}

export const MascotSleeping: FC<MascotSleepingProps> = (props) => {
  const hairColor = props.mode === "dark" ? "#fff" : "#e1f1ef";
  const hairColorContrast = props.mode === "dark" ? "#eee" : "#98cbcb";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={props.style}
      viewBox="0 -40 450 520"
    >
      <defs>
        <style>
          {`
          .MascotSleeping.cls-1 { fill: #9cc; }
          .MascotSleeping.cls-2 { fill: #98cbcb; }
          .MascotSleeping.cls-3 { fill: #7fadac; }

          /* MØRK KONTAKTSKYGGE */
          .MascotSleeping.cls-4 {
          fill: #5f8f8f;
          opacity: 0.75;
        }

          .MascotSleeping.cls-5 {
          fill: ${hairColor};
          stroke: ${hairColorContrast};
          stroke-width: 2.2;
          stroke-linejoin: round;
          stroke-linecap: round;
        }`}
        </style>
      </defs>

      {/*<!-- ================= BEIN ================= -->*/}
      <g>
        <path
          className="MascotSleeping cls-1"
          d="M222.5258,443.03968l-14.14664.64308-5.02914.22959-88.66653,4.08765,18.04997-31.64533,53.43898,11.43639-45.30938-48.91486c6.10842-3.97285,12.26281-7.92286,18.37179-11.89572.09195-.04597.16091-.1148.2523-.16077,7.55549-4.8915,37.31769-24.82487,44.36859-29.39483,10.17266.55113,10.7008,6.59087,17.3155,11.9187-5.58083,4.01883-20.92168,13.31952-26.75481,17.47613-.09195.04597-.16035.1148-.22875.16077-7.30319,5.23589-14.58283,10.51789-21.88602,15.75377l38.14411,45.81467,3.16999,3.81208,8.91005,10.67866Z"
        />
        <path
          className="MascotSleeping cls-1"
          d="M227.4742,443.03968l14.14664.64308,5.02914.22959,88.66653,4.08765-18.04997-31.64533-53.43898,11.43639,45.30938-48.91486c-6.10842-3.97285-12.26281-7.92286-18.37179-11.89572-.09195-.04597-.16091-.1148-.2523-.16077-7.55549-4.8915-37.31769-24.82487-44.36859-29.39483-10.17266.55113-10.7008,6.59087-17.3155,11.9187,5.58083,4.01883,20.92168,13.31952,26.75481,17.47613.09195.04597.16035.1148.22875.16077,7.30319,5.23589,14.58283,10.51789,21.88602,15.75377l-38.14411,45.81467-3.16999,3.81208-8.91005,10.67866Z"
        />
      </g>

      {/*<!-- ================= SKYGGE ================= -->*/}
      <g>
        <path
          className="MascotSleeping cls-4"
          d="M221.17124,349.34359c-5.58083,4.01883-20.92168,13.31952-26.75481,17.47613h-34.92927c7.55549-4.8915,37.31769-24.82487,44.36859-29.39483,10.17266.55113,10.7008,6.59087,17.3155,11.9187Z"
        />
        <path
          className="MascotSleeping cls-4"
          d="M228.82876,349.34359c5.58083,4.01883,20.92168,13.31952,26.75481,17.47613h34.92927c-7.55549-4.8915-37.31769-24.82487-44.36859-29.39483-10.17266.55113-10.7008,6.59087-17.3155,11.9187Z"
        />
      </g>

      {/*<!-- ================= KROPP ================= -->*/}
      <g>
        <path
          className="MascotSleeping cls-2"
          d="M130.79179,170.55236h188.41643v165.56629c0,12.61133-10.2388,22.85014-22.85014,22.85014h-142.71616c-12.61133,0-22.85014-10.2388-22.85014-22.85014v-165.56629Z"
        />
        <rect
          className="MascotSleeping cls-2"
          x="97.1367"
          y="150.21344"
          width="255.72661"
          height="49.29787"
        />
      </g>

      {/*<!-- ================= ANSIKT ================= -->*/}
      <g>
        <rect
          x="182.91484"
          y="205.98149"
          width="81.16671"
          height="7.47856"
          rx="3.73927"
          ry="3.73927"
          transform="translate(31.78206 -29.40089) rotate(8.10059)"
        />
        <path
          className="MascotSleeping cls-3"
          d="M216.30742,238.69122c1.92178,1.73678-6.54372,15.5478-19.96801,15.5478s-21.88979-13.81102-19.96801-15.5478c1.4359-1.29769,8.15581,4.61072,19.96801,4.61072s18.53212-5.90842,19.96801-4.61072Z"
        />
        <path
          className="MascotSleeping cls-3"
          d="M233.69258,240.30461c-1.92178,1.73678,6.54372,15.5478,19.96801,15.5478,13.42429,0,21.88979-13.81102,19.96801-15.5478-1.4359-1.29769-8.15581,4.61072-19.96801,4.61072s-18.53212-5.90842-19.96801-4.61072Z"
        />
        <circle cx="225" cy="282.647" r="11.78512" />
      </g>

      {/*<!-- ================= SØVN-Z ================= -->*/}
      <g className="MascotSleeping cls-5">
        <path
          d="M6 8 Q6 0 14 0 H58 Q66 0 66 8 Q66 14 60 18 L28 52 H58 Q66 52 66 60 Q66 68 58 68 H14 Q6 68 6 60 Q6 54 12 50 L44 16 H14 Q6 16 6 8 Z"
          transform="translate(196 85) scale(0.85) rotate(-6 33 34)"
          opacity="1"
        />

        {/*<!-- Midterste -->*/}
        <path
          d="M6 8 Q6 0 14 0 H58 Q66 0 66 8 Q66 14 60 18 L28 52 H58 Q66 52 66 60 Q66 68 58 68 H14 Q6 68 6 60 Q6 54 12 50 L44 16 H14 Q6 16 6 8 Z"
          transform="translate(256 45) scale(1.05) rotate(5 33 34)"
          opacity="0.9"
        />

        {/*<!-- Øverste -->*/}
        <path
          d="M6 8 Q6 0 14 0 H58 Q66 0 66 8 Q66 14 60 18 L28 52 H58 Q66 52 66 60 Q66 68 58 68 H14 Q6 68 6 60 Q6 54 12 50 L44 16 H14 Q6 16 6 8 Z"
          transform="translate(321 -5) scale(1.3) rotate(-9 33 34)"
          opacity="0.8"
        />
      </g>
    </svg>
  );
};
